import * as React from 'react';
import { ENV } from '~/common/enums/enums';
import { footerPayload, headerPayload } from '~/common/payload/payload';
import {
  HowAcademyWorks,
  Timeline,
  Reviews,
  Questions,
  LandingVideo,
  Directions,
  Benefits,
  EmbedVideo,
  ProgramBenefits,
  Statistics,
  TeamComposition,
  Blogs,
} from '~/components/sections/sections';
import { Layout } from '~/components/common/common';
import {
  howAcademyWorksPayload,
  timelinePayload,
  reviewPayload,
  questionsPayload,
  directionsPayload,
  landingPayload,
  benefitsPayload,
  seoPayload,
  embedVideoPayload,
  statisticsPayload,
  teamCompositionPayload,
  blogsPayload,
  programBenefitsPayload,
} from './data/data';
import * as styles from './main-page.module.scss';

const Page: React.FC = () => (
  <Layout
    seoPayload={seoPayload}
    headerPayload={headerPayload}
    footerPayload={footerPayload}
    registrationLink={ENV.APP.REGISTRATION_LINK}
  >
    <h1 className="visually-hidden">Binary Studio Academy</h1>
    <LandingVideo
      payload={landingPayload}
      registrationLink={ENV.APP.REGISTRATION_LINK}
    />
    <ProgramBenefits payload={programBenefitsPayload} />
    <Statistics payload={statisticsPayload} />
    <HowAcademyWorks payload={howAcademyWorksPayload} />
    <Directions
      payload={directionsPayload}
      type="primary"
      sectionHighlight="secondary"
      className={styles.directions}
    />
    <Benefits
      payload={benefitsPayload}
      registrationLink={ENV.APP.REGISTRATION_LINK}
    />
    <TeamComposition payload={teamCompositionPayload} />
    <Timeline payload={timelinePayload} />
    <Reviews payload={reviewPayload} />
    <EmbedVideo payload={embedVideoPayload} />
    <Blogs payload={blogsPayload} sectionHighlight="secondary" />
    <Questions payload={questionsPayload} />
    <Directions
      payload={directionsPayload}
      type="secondary"
      className={styles.directionsFooter}
    />
  </Layout>
);

export { Page };
